import { useQuery } from '@tanstack/react-query';
import { getIncompleteCost } from '../value.api';

export function useIncompleteCost(gln: string) {
  return useQuery({
    queryKey: ['value', 'incomplete-cost', gln],
    queryFn: () => getIncompleteCost(gln),
    enabled: !!gln,
    staleTime: 5 * 60 * 1000,
  });
}
